// extracted by mini-css-extract-plugin
export default {"container":"ResizableVegaLiteEmbed_container__mSmqo","handle":"ResizableVegaLiteEmbed_handle__frlC7"};